(function ($) {
  Drupal.behaviors.fwp3414ImageContentV1 = {
    formatter: $('.fwp-3-4-1-4-image-content-v1'),
    button: $('.action-button', this.formatter),

    attach: function (context, settings) {
      var buttonLink = this.button.children('a');
      var buttonHref = buttonLink.attr('href');

      // Link the hero image to the same location as the cta button
      this.formatter.find('.hero').children('img').wrap('<a></a>').parent('a').attr('href', buttonHref);

      // Custom CTA added via the node's WYSIWYG editor using these classes: button cta offer-cta. This custom CTA will need the data-productid and the data-skubaseid and should be in this format:
      // <a class="button cta offer-cta" href="#" title="Add to Bag" data-product-title="Product Title" data-productid="PROD12345" data-skubaseid="12345" style="display: inline-block;">Add to Bag</a>
      var thisFormatter = this.formatter;
      var cta = thisFormatter.find('.button.cta.offer-cta');

      if (typeof cta !== 'undefined' && cta.hasClass('offer-cta')) {
        thisFormatter.find('.wrapper-link').css({ 'cursor': 'default' });
        cta.each(function () {
          var thisCta = $(this);

          thisCta.once('offer-cta').on('click', function(e) {
            e.preventDefault();
            // iterate through each product div to get sku for 'add all to cart'
            var buySkus = [];
            var self = $(this);
            var productId = thisCta.attr('data-productid');
            var skuBaseId = thisCta.attr('data-skubaseid');

            self.each(function () {
              buySkus.push(skuBaseId);
            });

            var loadingId = site.loading.show({
              'target': thisCta,
              'matchTarget': ['display', 'height', 'width'],
              'css': {
                'text-align': 'center',
                'vertical-align': 'bottom',
                'margin-bottom': '0'
              }
            });

            // add sku array to cart
            site.addToCart({
              skuBaseId: buySkus
            });

            $(document).one('addToCart.success addToCart.failure', function () {
              site.loading.hide(loadingId);
            });
          });
        });
      }
    }
  };
})(jQuery);
